module.exports = __webpack_public_path__ + "img/html-5.9ebaf00a.svg";